import Api from './Api';

/* Thin wrapper over the /admin/roles/* endpoints. Every call already flows through Api,
   which handles the Invalid-Token redirect, so these just name the routes. */
class Roles {
    modules() { return Api.get('roles/modules'); }

    list() { return Api.post('roles/list', {}); }
    get(id) { return Api.get('roles/' + id); }
    create(obj) { return Api.post('roles/create', obj); }
    update(obj) { return Api.post('roles/update', obj); }
    remove(id) { return Api.post('roles/delete', { id }); }

    userList(obj) { return Api.post('roles/users/list', obj); }
    userCreate(obj) { return Api.post('roles/users/create', obj); }
    userUpdate(obj) { return Api.post('roles/users/update', obj); }
    userStatus(id) { return Api.post('roles/users/status', { id }); }
    userRemove(id) { return Api.post('roles/users/delete', { id }); }
}
export default new Roles();
